import { Box, Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { TruncatedTextBodyMedium } from 'screens/Levelup/LevelUpCF/constants';
import {
  updateConfigData,
  useConfigDataSelector,
} from 'screens/admin/Objectives/GoalPreferences/slice/accessControlSlice';

import { CascadedViewV2 } from 'assets/assetsV1/iconComponents';

import { getBooleanValue } from 'constants/helper';

import { Checkbox } from 'uiToolkitV1/Checkbox';
import { Divider } from 'uiToolkitV1/Divider';
import { SelectV2 } from 'uiToolkitV1/SelectV2';
import { TextBodyLarge, TextLabel } from 'uiToolkitV1/Typography';

import { OBJECTIVE_TYPE } from '../../helpers';
import ModuleItem from './ModuleItem';

const Cascade = ({ isEditMode }) => {
  const dispatch = useDispatch();

  const { configData } = useConfigDataSelector();

  const onChange = (key, value) => {
    dispatch(updateConfigData({ key, value }));
  };
  return (
    <Box padding="1rem">
      <Flex mb="1rem" justifyContent="space-between" alignItems="center">
        <CascadedViewV2 boxSize="24px" color="#666666" />
        <Box style={{ flexGrow: 1 }} ml="8px">
          <TextBodyLarge style={{ fontWeight: '600' }}>How to cascade</TextBodyLarge>
          <TextLabel color="text.g2">Allow users to create children for Objectives and KRs</TextLabel>
        </Box>
      </Flex>

      <Divider />

      <ModuleItem
        title="Enable cascading Key Results"
        description="Allow users to create child goals for Key Results. Suitable for organizations that wish to break down complex Key Results into smaller, contributing goals for granular tracking."
        component={
          <Checkbox
            disabled={!isEditMode}
            onChange={(e) => {
              onChange('IS_KR_CASCADING_ENABLED', String(e.target.checked));
            }}
            isChecked={getBooleanValue(configData?.IS_KR_CASCADING_ENABLED?.value)}
          />
        }
      />
      <ModuleItem
        title="Define Objective Type"
        description="Select what type of Objectives are most relevant for your methodologies"
        component={
          <Box
            sx={{
              '.chakra-menu__menu-list': {
                width: '50%',
                marginLeft: 'auto',
              },
            }}
          >
            <SelectV2
              menuItems={OBJECTIVE_TYPE}
              onSelect={(data) => {
                onChange('OBJECTIVE_TYPE', data.value);
              }}
              isReadOnly={!isEditMode}
              selectedItem={OBJECTIVE_TYPE.find((objective) => objective.value === configData?.OBJECTIVE_TYPE?.value)}
              placeholder="Choose objective type"
              renderControlItem={(menuItem) => <TruncatedTextBodyMedium> {menuItem?.label} </TruncatedTextBodyMedium>}
              renderMenuItem={(menuItem) => (
                <Box>
                  <TruncatedTextBodyMedium> {menuItem?.label} </TruncatedTextBodyMedium>

                  <TextLabel color="#666666 !important">{menuItem?.description}</TextLabel>
                </Box>
              )}
            />
          </Box>
        }
      />

      {/* <ModuleItem
        title={'Make Parent Goal Mandatory'}
        description={'Allow users to create parentless objectives/ goals'}
        component={
          <Checkbox
            onChange={(e) => {
              onChange('IS_PARENT_MANDATORY', String(e.target.checked));
            }}
            disabled={!isEditMode}
            isChecked={getBooleanValue(configData?.IS_PARENT_MANDATORY?.value)}
          />
        }
      /> */}
      {/* <ModuleItem
        title={'Allow Managers/ Admins create Goal'}
        description={'Only Goal Admin and Managers can create Goals & objectives without parent'}
        component={
          <Checkbox
            onChange={(e) => {
              onChange('IS_PARENT_MANDATORY', e.target.checked);
            }}
            disabled={!isEditMode}
            isChecked={getBooleanValue(configData?.IS_PARENT_MANDATORY?.value)}
          />
        }
      /> */}
    </Box>
  );
};

export default Cascade;
